import numeral from "numeral";
import { useMemo } from "react";
import { useTaxStore } from "../../../_store/taxplanStore";
import { cn } from "../../../utils/useFunctions";
import {
  PdfCard,
  PdfCardGray,
  PdfCardWhite
} from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import {
  PdfHeaderText
} from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_12,
  STYLE_PDF_TEXT_MEDIUM_BLUE_11,
  STYLE_PDF_TEXT_MEDIUM_BLUE_12
} from "../styles/pdf.style";

function PdfPageTaxThree({ page }) {
  const taxData = useTaxStore((state) => state.taxData);

  const deductionItems = useMemo(() => {
    const newDeductionItems = [
      {
        label: "เงินสะสมกองทุนสำรองเลี้ยงชีพ",
        value: taxData?.fund_provident || "",
      },
      {
        label: "เงินสะสมกองทุนการออมแห่งชาติ (กอช)  ",
        value: taxData?.fund_nsf || "",
      },
      {
        label: "ค่าซื้อหน่วยลงทุนกองทุนรวมไทยเพื่อความยั่งยืน (Thailand ESG)",
        value: taxData?.fund_esg || "",
      },
      {
        label: "ค่าซื้อหน่วยลงทุนในกองทุนรวมเพื่อการเลี้ยงชีพ (RMF)",
        value: taxData?.fund_provident_rmf_value || "",
      },
      {
        label: "ค่าซื้อหน่วยลงทุนในกองทุนรวมเพื่อการออม (SSF)",
        value: taxData?.fund_provident_ssf_value || "",
      },
    ];
    return newDeductionItems;
  }, [taxData]);

  const deductionItems2 = useMemo(() => {
    const newDeductionItems = [
      {
        label: "ดอกเบี้ยเงินกู้ยืมเพื่อซื้อ เช่าซื้อ หรือสร้างอาคารอยู่อาศัย",
        value: taxData?.home_loan || "",
      },
      {
        label: "เงินสมทบกองทุนประกันสังคม",
        value: taxData?.fund_social_security || "",
      },
      {
        label: "ค่าฝากครรภ์และค่าคลอดบุตร",
        value: taxData?.prenatal_care_cost || "",
      },
    ];
    return newDeductionItems;
  }, [taxData]);

  const deductionItems3 = useMemo(() => {
    const newDeductionItems = [
      {
        label: "ประกันชีวิต",
        value: taxData?.tax_plan_insurance_life || "",
      },
      {
        label: "ประกันสุขภาพ",
        value: taxData?.tax_plan_insurance_health || "",
      },
      {
        label: "ประกันชีวิตแบบบำนาญ",
        value: taxData?.tax_plan_insurance_annuity || "",
      },
      {
        label: "เงินสะสมกองทุนการออมแห่งชาติ (กอช)",
        value: taxData?.tax_fund_nsf || "",
      },
      {
        label: "ค่าซื้อหน่วยลงทุนกองทุนรวมไทยเพื่อความยั่งยืน (Thailand ESG)",
        value: taxData?.tax_fund_esg || "",
      },
      {
        label: "กองทุนรวมเพื่อการเลี้ยงชีพ (RMF)",
        value: taxData?.tax_plan_rmf || "",
      },
      {
        label: "กองทุนรวมเพื่อการออม (SSF)",
        value: taxData?.tax_plan_ssf || "",
      },
      {
        label: "เงินบริจาคแก่พรรคการเมือง",
        value: taxData?.tax_plan_political_donate || "",
      },
    ];
    return newDeductionItems;
  }, [taxData]);

  const total = useMemo(() => {
    let sum_total = deductionItems.reduce((acc, item) => {
      return acc + +item.value;
    }, 0);
    return sum_total;
  }, [taxData]);

  const total2 = useMemo(() => {
    let sum_total = deductionItems3.reduce((acc, item) => {
      return acc + +item.value;
    }, 0);
    return sum_total;
  }, [taxData]);

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="วางแผนภาษี"
        icon="/images/tax_plan.svg"
        classNameIcon="w-[24px] h-[27px]"
      />
      {/* วางแผนภาษี */}
      <PdfCard className={"flex flex-col space-y-3"} title={"ค่าลดหย่อน"}>
        {/* ก่อนวางแผน ครอบครัว */}
        <PdfCardWhite className={cn("px-3")}>
          {/* <div className={cn("flex items-center space-x-1")}>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_12)}>ก่อนวางแผน</div>
          </div> */}

          <div
            className={cn(
              "flex justify-between mx-1 mt-1",
              STYLE_PDF_TEXT_MEDIUM_12
            )}
          >
            <div>รายการลดหย่อน</div>
            <div>ต่อปี</div>
          </div>

          <PdfLine />

          <div className={cn("mt-1 flex items-center space-x-2")}>
            <div>
              <img src="/images/salary_2.svg" />
            </div>

            <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
              ค่าลดหย่อนหน่วยลงทุน
            </div>
          </div>

          <PdfCardGray className={cn("px-3 mt-1")}>
            {deductionItems.map((item, index) => {
              return (
                <div
                  key={index}
                  className="flex justify-between space-x-1 mt-1"
                >
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                    {item?.label}
                  </div>
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_11)}>
                    {numeral(item?.value).format("0,0")} บาท
                  </div>
                </div>
              );
            })}
          </PdfCardGray>

          <div className="flex space-x-1 justify-center mt-2">
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>รวม</div>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_12)}>
              {numeral(total).format("0,0")} บาท
            </div>
          </div>
        </PdfCardWhite>

        {/* ก่อนวางแผน ประกัน */}
        <PdfCardWhite className={cn("px-3")}>
          {/* <div className={cn("flex items-center space-x-1")}>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_12)}>ก่อนวางแผน</div>
          </div> */}

          <div
            className={cn(
              "flex justify-between mx-1 mt-1",
              STYLE_PDF_TEXT_MEDIUM_12
            )}
          >
            <div>รายการลดหย่อน</div>
            <div>ต่อปี</div>
          </div>

          <PdfLine />

          <div className={cn("mt-1 flex items-center space-x-2")}>
            <div>
              <img src="/images/salary_2.svg" />
            </div>

            <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>ค่าลดหย่อนอื่น ๆ</div>
          </div>

          <PdfCardGray className={cn("px-3 mt-1")}>
            {deductionItems2.map((item, index) => {
              return (
                <div
                  key={index}
                  className="flex justify-between space-x-1 mt-1"
                >
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                    {item?.label}
                  </div>
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_11)}>
                    {numeral(item?.value).format("0,0")} บาท
                  </div>
                </div>
              );
            })}
          </PdfCardGray>

          <div className="flex space-x-1 justify-center mt-2">
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>รวม</div>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_12)}>
              {numeral(total).format("0,0")} บาท
            </div>
          </div>
        </PdfCardWhite>

        {/* หลังวางแผน */}
        {/* <PdfCardWhite className={cn("px-3")}>
          <div className={cn("flex items-center space-x-1")}>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_12)}>หลังวางแผน</div>
          </div>

          <div
            className={cn(
              "flex justify-between mx-1 mt-1",
              STYLE_PDF_TEXT_MEDIUM_12
            )}
          >
            <div>รายการลดหย่อนทั้งหมดหลังวางแผนเพิ่มเติม</div>
            <div>ต่อปี</div>
          </div>

          <PdfLine />

          <div className={cn("mt-1 flex items-center space-x-2")}>
            <div>
              <img src="/images/profit_growth_pdf.svg" />
            </div>

            <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
              ค่าลดหย่อน/ยกเว้น ด้านการออมและการลงทุน
            </div>
          </div>

          <PdfCardGray className={cn("px-3 mt-1")}>
            {deductionItems3.map((item, index) => {
              return (
                <div
                  key={index}
                  className="flex justify-between space-x-1 mt-1"
                >
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                    {item?.label}
                  </div>
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_11)}>
                    {numeral(item?.value).format("0,0")} บาท
                  </div>
                </div>
              );
            })}
          </PdfCardGray>

          <div className="flex space-x-1 justify-center mt-1">
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>รวม</div>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_12)}>
              {numeral(total2).format("0,0")} บาท
            </div>
          </div>
        </PdfCardWhite> */}
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageTaxThree;
